module.exports = __webpack_public_path__ + "static/img/5.a66ff9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tx/5.jpg
// module id = gtJy
// module chunks = 0